import { render, staticRenderFns } from "./gcgk.vue?vue&type=template&id=617d0ef5&scoped=true&"
import script from "./gcgk.vue?vue&type=script&lang=js&"
export * from "./gcgk.vue?vue&type=script&lang=js&"
import style0 from "./gcgk.vue?vue&type=style&index=0&id=617d0ef5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d0ef5",
  null
  
)

export default component.exports